import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex';
import store from './store'
import vuetify from './plugins/vuetify';
import Vuelidate from 'vuelidate'
import RestaurantAddressModal from '@/components/Restaurants/RestaurantAddressModal'
import NewRestaurantModal from '@/components/Restaurants/NewRestaurantModal'
import NewAreaModal from '@/components/Areas/NewAreaModal'
import EditAreaModal from '@/components/Areas/EditAreaModal'
import EditRestaurantModal from '@/components/Restaurants/EditRestaurantModal'
import EditRestaurantProfileModal from '@/components/Auth/EditRestaurantProfileModal'
import DriversListModal from '@/components/Drivers/DriversListModal'
import NewPostModal from '@/components/NewsFeed/NewPostModal'
import EditPostModal from '@/components/NewsFeed/EditPostModal'
import NewDriverModal from '@/components/Drivers/NewDriverModal';
import NewDriverHalfBoardModal from '@/components/Drivers/NewDriverHalfBoardModal';
import ViewDriverModal from '@/components/Drivers/ViewDriverModal';
import EditDriverModal from '@/components/Drivers/EditDriverModal';
import NewReplyModal from '@/components/NewsFeed/NewReplyModal';
import NewShiftModal from '@/components/Schedule/NewShiftModal';
import EditShiftModal from '@/components/Schedule/EditShiftModal';
import CopyShiftsModal from '@/components/Schedule/CopyShiftsModal';
import NewShiftRestaurantModal from '@/components/ScheduleRestaurant/NewShiftRestaurantModal';
import EditShiftRestaurantModal from '@/components/ScheduleRestaurant/EditShiftRestaurantModal';
import CopyShiftsRestaurantModal from '@/components/ScheduleRestaurant/CopyShiftsRestaurantModal';
import NewTimesheetModal from '@/components/Timesheet/NewTimesheetModal';
import NewTimesheetRestaurantModal from '@/components/TimesheetRestaurant/NewTimesheetRestaurantModal';
import RequestInvoiceModal from '@/components/Timesheet/RequestInvoiceModal';
import RequestInvoiceRestaurantModal from '@/components/TimesheetRestaurant/RequestInvoiceRestaurantModal';
import AlertsDropdownMenu from '@/components/Alerts/AlertsDropdownMenu';
import EditOptionModal from '@/components/Options/EditOptionModal';
import EditOptionMapModal from '@/components/Options/EditOptionMapModal';
import CancelShiftModal from '@/components/Schedule/CancelShiftModal';
import * as VueGoogleMaps from 'vue2-google-maps';
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import configs from './configs/config';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import '@mdi/font/css/materialdesignicons.css'

Vue.prototype.appConfig = configs;

if (process.env.NODE_ENV == 'production') {
  Sentry.init({
    dsn: 'https://65ed48751a80417fbe6ba076faf90188@o387656.ingest.sentry.io/5225156',
    integrations: [new VueIntegration({Vue, attachProps: true, logErrors: true})],
  });  
}

Vue.use(VueGoogleMaps, {
  load: {
    key: configs.GOOGLE_MAP_API_KEY, // need config API key with enabled billing
    // libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})

Vue.use(Vuex, vuetify, Vuelidate);

Vue.use(TiptapVuetifyPlugin, {
  vuetify: vuetify,
  iconsGroup: 'mdi'
})

Vue.config.productionTip = false;


Vue.component('restaurant-address-modal', RestaurantAddressModal)
Vue.component('new-restaurant-modal', NewRestaurantModal)
Vue.component('new-driver-modal', NewDriverModal)
Vue.component('new-driver-half-board-modal', NewDriverHalfBoardModal)
Vue.component('new-area-modal', NewAreaModal)
Vue.component('edit-area-modal', EditAreaModal)
Vue.component('edit-restaurant-modal', EditRestaurantModal)
Vue.component('edit-restaurant-profile-modal', EditRestaurantProfileModal)
Vue.component('drivers-list-modal', DriversListModal)
Vue.component('new-post-modal', NewPostModal)
Vue.component('edit-post-modal', EditPostModal)
Vue.component('view-driver-modal', ViewDriverModal)
Vue.component('edit-driver-modal', EditDriverModal)
Vue.component('new-reply-modal', NewReplyModal)
Vue.component('new-shift-modal', NewShiftModal)
Vue.component('edit-shift-modal', EditShiftModal)
Vue.component('copy-shifts-modal', CopyShiftsModal)
Vue.component('new-shift-restaurant-modal', NewShiftRestaurantModal)
Vue.component('edit-shift-restaurant-modal', EditShiftRestaurantModal)
Vue.component('copy-shifts-restaurant-modal', CopyShiftsRestaurantModal)
Vue.component('new-timesheet-modal', NewTimesheetModal)
Vue.component('new-timesheet-restaurant-modal', NewTimesheetRestaurantModal)
Vue.component('request-invoice-modal', RequestInvoiceModal)
Vue.component('request-invoice-restaurant-modal', RequestInvoiceRestaurantModal)
Vue.component('alerts-dropdown-menu', AlertsDropdownMenu)
Vue.component('edit-option-modal', EditOptionModal)
Vue.component('edit-option-map-modal', EditOptionMapModal)
Vue.component('cancel-shift-modal', CancelShiftModal)

Object.defineProperty(Vue.prototype,"$bus",{
    get: function() {
        return this.$root.bus;
    }
});

new Vue({
    data: {
        bus: new Vue({}) // Here we bind our event bus to our $root Vue model.
    },
    icons: {
        iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
    },
  render: h => h(App),
    vuetify,
    router,
    store,
created(){
    // this.$store.dispatch('fetchRestaurants')
    // this.$store.dispatch('fetchPosts')
    // this.$store.dispatch('fetchReplies')
}
}).$mount('#app')
